export default "__VITE_ASSET__butwhIFz__"